import { PropTypes } from "@l2r-front/l2r-proptypes"
import { formatDate } from "@l2r-front/l2r-utils"

import { AUTHOR_FILTER, DATE_FROM_FILTER, DATE_TO_FILTER, FILE_TYPE_FILTER, FILTERS } from "../../constants/filters"
import { useDocumentContext } from "../../contexts/DocumentContext"
import { useDocumentAuthors } from "../../hooks/queries/useDocumentAuthors"
import { useDocumentProject } from "../../hooks/queries/useDocumentProject"
import { useDocumentTypes } from "../../hooks/queries/useDocumentTypes"

import { DocumentFiltersForm } from "./DocumentFiltersForm"
import { DocumentFiltersFormSkeleton } from "./DocumentFiltersForm.skeleton"

export function DocumentFiltersFormPost(props) {

    const {
        close,
        enabledFilters,
    } = props

    const { data: documentTypes } = useDocumentTypes()
    const { data: project } = useDocumentProject()
    const { data: users } = useDocumentAuthors()

    const [state, dispatch] = useDocumentContext()
    const { applyFilters } = dispatch
    const { filters } = state

    if (!documentTypes || !project) {
        return <DocumentFiltersFormSkeleton />
    }

    return <DocumentFiltersForm
        close={close}
        enabledFilters={enabledFilters}
        fileTypes={documentTypes}
        filters={filters}
        onSubmit={(values) => {
            const formData = {
                ...values,
                [AUTHOR_FILTER]: values[AUTHOR_FILTER]?.map(user => user.uuid) || [],
                [DATE_FROM_FILTER]: formatDate(values[DATE_FROM_FILTER], "dd-MM-yyyy") || null,
                [DATE_TO_FILTER]: formatDate(values[DATE_TO_FILTER], "dd-MM-yyyy") || null,
                [FILE_TYPE_FILTER]: values[FILE_TYPE_FILTER] ? values[FILE_TYPE_FILTER]?.map(fileType => fileType.name) : [],
            }
            applyFilters(formData)
            close()
        }}
        project={project}
        setFilters={applyFilters}
        users={users}
    />
}

DocumentFiltersForm.propTypes = {
    close: PropTypes.func.isRequired,
    enabledFilters: PropTypes.arrayOf(PropTypes.oneOf(FILTERS)).isRequired,
}
